<template>
  <gt-dialog :visible.sync="dialogVisible"
             @closed="close">
    <div class="gt-modal__body">
      <div class="gt-modal__content">
        <h1>自定义行业</h1>
        <div class="info-body">
          <table>
            <tbody>
              <tr>
                <td class="cell-title">行业名称：</td>
                <td class="cell-value">
                  <gt-input name="text"
                            placeholder="请输入行业名称"
                            v-validate="'required|trim'"
                            v-model.trim="name">
                  </gt-input>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="info-footer">
          <gt-button class="footer-btn"
                     @click="close">取消</gt-button>
          <button class="footer-btn theme-btn"
                  @click="comfirm">确认</button>
        </div>
      </div>
    </div>
  </gt-dialog>
</template>

<script>
export default {
  name: 'CustomName',
  data () {
    return {
      name: '',
      dialogVisible: false
    }
  },
  methods: {
    open () {
      this.dialogVisible = true
    },
    comfirm () {
      if (this.name) {
        this.$emit('customIndustry', this.name)
      }
      this.close()
    },
    close () {
      this.name = ''
      this.dialogVisible = false
    }
  },
  created () {

  }
}
</script>

<style lang='less' scoped>
/deep/.gt-dialog {
  width: 450px;
  .gt-dialog__header {
    border: none;
  }
  .gt-dialog__body {
    padding-top: 0;
    padding-bottom: 20px;
  }
}
h1 {
  display: block;
  widows: 100%;
  color: #151515;
  font-size: 16px;
  margin-bottom: 30px;
  text-align: left;
}
.info-body {
  width: 410px;
  height: 100px;
  // padding: 30px 70px;
  // margin-bottom: 20px;
  border-radius: 4px;
  table {
    .cell-title {
      width: 80px;
      color: #666666;
      text-align: left;
    }
    .cell-value {
      color: #333333;
    }
    td {
      font-size: 14px;
      line-height: 30px;
      .gt-input {
        width: 240px;
      }
    }
  }
}
.info-footer {
  text-align: right;
}
/deep/.footer-btn {
  // width: 150px;
  margin-left: 16px;
}
</style>
